<template>
    <div>
        <Header />
        <main class="content-fluid">
            <router-view />
        </main>
        <div class="floating-button" @click="redirectToWhatsApp">
            <img class="" alt="" src="../../public/assets/images/logos/Whatsapp Widget.png" />
        </div>
    </div>
</template>

<script>
import Header from '../components/default/Header.vue';
import Footer from '../components/default/Footer.vue';
import { useAnimations } from '../components/logicas/useAnimations';
import { data } from '../data/configApp';
import { ref, onMounted, onUnmounted, provide } from 'vue';

export default {
    name: 'App',
    components: {
        Header,
        Footer
    },
    setup() {
        useAnimations(); // Aplica animaciones globalmente a todas las vistas
        const screenWidth = ref(window.innerWidth);

        const updateWidth = () => {
            screenWidth.value = window.innerWidth;
        };

        onMounted(() => {
            window.addEventListener('resize', updateWidth);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', updateWidth);
        });

        provide('screenWidth', screenWidth);

        const getImageUrl = (imgPath) => {
            return `${window.location.origin}/${imgPath}`;
        };

        provide('getImageUrl', getImageUrl);

        return {
            screenWidth
        };
    },
    data() {
        return {
            telefonoFriax: data.VUE_APP_TELEFONO_FRIAX,
            messageWhatsappFriax: data.VUE_APP_MESSAGE_WHATSAPP_FRIAX,
        };
    },
    methods: {
        redirectToWhatsApp() {
            const newMessage = encodeURIComponent(this.messageWhatsappFriax);
            let url = 'https://wa.me/' + this.telefonoFriax + '?text=' + newMessage;
            window.open(url, '_blank');
        },
    }
}
</script>

<style>
/* Agrega estilos globales aquí */
.content {
    /* min-height: calc(100vh - 112px); */
    /* Altura total menos header y footer */
}

.floating-button {
    position: fixed;
    margin-left: 60px !important;
    bottom: 60px;
    right: 6%;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    z-index: 1000;
}
</style>